import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sb-event-library',
  template: `
    <p>
      event-library works!
    </p>
  `,
  styles: []
})
export class EventLibraryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
